import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import VideoUploadInput from "./VideoUploadInput";
import TagsInput from "./TagsInput";
import { VideoUploadProvider } from "./VideoUploadContext";
import { TrainingVideoCreateToolbar } from "./TrainingVideoSaveToolbar";
import {
  validateTitle,
  validatePriority,
  validateTags,
  validateIntroTime,
  validateVietnameseIntroTime,
} from "./util";

const useStyles = makeStyles(() => ({
  container: { width: "90%", margin: "auto" },
}));

const TrainingVideoCreate = (props) => {
  const classes = useStyles();

  return (
    <Create {...props}>
      <VideoUploadProvider>
        <SimpleForm redirect="list" toolbar={<TrainingVideoCreateToolbar />}>
          <Grid
            container
            spacing={2}
            className={classes.container}
            justify="space-between"
          >
            <Grid item xs={12} md={6}>
              <TextInput
                source="title"
                label="Title"
                validate={validateTitle}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <NumberInput
                source="priority"
                label="Priority"
                initialValue={0}
                validate={validatePriority}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextInput source="summary" label="Summary" multiline fullWidth />
            </Grid>
            <Grid item xs={12} md={6}>
              <BooleanInput
                source="active"
                label="Active"
                initialValue={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TextInput
                source="description"
                label="Description"
                multiline
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <TagsInput source="tags" label="Tags" validate={validateTags} />
            </Grid>
            <Grid item xs={12} md={6}>
              <VideoUploadInput
                source="video_file_path"
                label="Video (Required)"
                required
                introTimeSource="intro_time"
                introTimeLabel="Intro Time (seconds)"
                introTimeValidate={validateIntroTime}
                introTimeRequired
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <VideoUploadInput
                source="vietnamese_video_file_path"
                label="Vietnamese Video (Optional)"
                clearable
                introTimeSource="vietnamese_intro_time"
                introTimeLabel="Vietnamese Intro Time (seconds)"
                introTimeValidate={validateVietnameseIntroTime}
              />
            </Grid>
          </Grid>
        </SimpleForm>
      </VideoUploadProvider>
    </Create>
  );
};

export default TrainingVideoCreate;
